"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fireEvent_1 = (0, tslib_1.__importDefault)(require("./fireEvent"));
const sleep_1 = (0, tslib_1.__importDefault)(require("./sleep"));
async function waitAndFire(name, data) {
    const results = await (0, fireEvent_1.default)(name, data);
    if (results.length === 0) {
        await (0, sleep_1.default)(100);
        return await waitAndFire(name, data);
    }
    return results;
}
exports.default = waitAndFire;
//# sourceMappingURL=waitAndFire.js.map